import { render, staticRenderFns } from "./ShipmentControlImport.vue?vue&type=template&id=563f4e55"
import script from "./ShipmentControlImport.vue?vue&type=script&lang=js"
export * from "./ShipmentControlImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports